import Vue from 'vue'
import Router from 'vue-router'
// Import Layouts
import iDalgoSelect from '@/layouts/iDalgo-Select'
import iDalgoSelection from '@/views/iDalgo-Selection'
import iDalgoResult from '@/layouts/iDalgo-Result'
import iDalgoResultMe from '@/views/iDalgo-Result-Me'
import iDalgoResultOther from '@/views/iDalgo-Result-Other'
// Import Views

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/selection/:id',
      name: 'select',
      meta: { requiresAuth: true },
      component: iDalgoSelect,
      redirect: '/selection/:id/steps/1',
      children: [
        {
          path: 'steps/:step',
          name: 'steps',
          component: iDalgoSelection
        }
      ]
    },
    {
      path: '/result/:id',
      name: 'result',
      component: iDalgoResult,
      children: [
        {
          path: 'me',
          name: 'my-result',
          component: iDalgoResultMe
        },
        {
          path: 'other',
          name: 'other-result',
          component: iDalgoResultOther
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js